import { render, staticRenderFns } from "./WeatherMatrix.vue?vue&type=template&id=1801946e&scoped=true&"
import script from "./WeatherMatrix.vue?vue&type=script&lang=js&"
export * from "./WeatherMatrix.vue?vue&type=script&lang=js&"
import style0 from "./WeatherMatrix.vue?vue&type=style&index=0&id=1801946e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801946e",
  null
  
)

export default component.exports